import React from 'react';

import { GetPropsCommonOptions, GetToggleButtonPropsOptions } from 'downshift';

import { BasicButton } from '@adsk/alloy-react-button';
import { ChevronDownIcon } from '@adsk/alloy-react-icon';
import theme, { StylableComponent } from '@adsk/alloy-react-theme';

type ToggleButtonProps = StylableComponent<HTMLButtonElement> & {
  getToggleButtonProps?: (
    options?: GetToggleButtonPropsOptions,
    otherOptions?: GetPropsCommonOptions,
    // The return value is typed 'any' in downshift, if they make it more specific we can match it in the future
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  ) => any;
  isOpen: boolean;
  disabled?: boolean;
  highlightButtonOnFocus?: boolean;
};

const ToggleButton = ({
  style,
  isOpen,
  getToggleButtonProps,
  highlightButtonOnFocus,
  as,
  ...props
}: ToggleButtonProps) => {
  const {
    style: _ignoredStyle,
    css: _ignoredCss,
    ...toggleButtonProps
  } = getToggleButtonProps?.(props) || props;

  return (
    <BasicButton
      data-testid={'ControlLabel__toggle'}
      as={as}
      style={{
        padding: 0,
        height: 32,
        cursor: props.disabled ? 'not-allowed' : undefined,
        ...(highlightButtonOnFocus &&
          !isOpen && {
            '&:focus-within': {
              svg: {
                boxShadow: theme.halos.focus,
                borderRadius: theme.borderRadius.small,
              },
            },
          }),
      }}
      {...toggleButtonProps}
    >
      <ChevronDownIcon
        style={[
          {
            color: theme.colors.charcoal700,
            ...(isOpen && {
              transform: 'rotate(180deg)',
            }),
          },
          style,
        ]}
      />
    </BasicButton>
  );
};

export default ToggleButton;
